<script>
import { createDrawingTool } from './drawing-tool.js'
export default createDrawingTool('FibonacciTool', function() {
            return {
                group: 'Fibonacci', category: 'Fibonacci', icon: this.getIcon('fibonacci'),
                type: 'Fibonacci',
                name: 'Fib Retracement',
                hint: 'Fibonacci Retracement',
                data: [],
                settings: {},
                mods: {
                    'Extension': {
                        settings: { extension: true },
                        category: 'Fibonacci',
                        icon: this.getIcon('fibonacci'),
                        hint: 'Fibonacci Extension',
                        name: 'Fib Extension'
                    }
                }
            }
        }, s => s.extension ? 'Fib Extension' : 'Fib Retracement')
</script>
